import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import TransomConfigurator from './../TransomConfigurator'
import { withTranslation, Trans } from 'react-i18next'
import { view03ImageOptions } from './views/view03'

class X46HullTreatment extends Component {
  constructor (props) {
    super(props)
    this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this)
  }

  handleHullTreatmentChange (newValue) {
    let configuration = this.props.configuration
    configuration.HullTreatment = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = view03ImageOptions

    let image = (
      <TransomConfigurator
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2895, height: 780 }}
        transform={[
          0.018313, -0.030559, 0, -7.1e-5, -0.010223, 0.029564, 0, -3.4e-5, 0,
          0, 1, 0, 207.448574, 218.683357, 0, 1
        ]}
      >
        <ConfiguratorImage
          boat='X4_6'
          configuration={this.props.configuration}
          options={imageOptions}
        />
      </TransomConfigurator>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Hull Treatment' />
          </h1>

          <p>
            <Trans defaults='3 layers of sprayed epoxy primer &amp; 2 layers of antifouling paint' />
          </p>

          <RadioGroup
            label={this.props.t('Treatment options:')}
            options={this.props.hullTreatmentOptions}
            value={this.props.configuration.HullTreatment}
            onChange={this.handleHullTreatmentChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46HullTreatment)



// WEBPACK FOOTER //
// ./src/X46/X46HullTreatment.js